import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Try a different payment method", -1)
const _hoisted_2 = { id: "creditcardfields" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "fieldleft" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_8 = { class: "fieldright" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)
const _hoisted_11 = { class: "fieldleft" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hint", { style: {"font-size":"12px"} }, "This is the 3 or 4 digit number on the back of the card.", -1)
const _hoisted_14 = { class: "fieldright" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("red", null, "*", -1)
const _hoisted_16 = { style: {"width":"40%","float":"left","margin-right":"1%"} }
const _hoisted_17 = ["value"]
const _hoisted_18 = { style: {"width":"50%","float":"left"} }
const _hoisted_19 = ["value"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)

import { PaymentMethod } from "@/models/PaymentMethod";
import ValidationError from "@/components/ValidationError.vue";
import { validateCard, validateCVV } from "@/utils/CreditCards";
import {
  defineComponent,
  Ref,
  ref,
  onMounted,
  computed,
  ComputedRef,
} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePaymentInfoModal',
  emits: ["payment-changed"],
  setup(__props, { emit }) {

const paymentMethod = ref(new PaymentMethod());
const validationErrors: Ref<any[]> = ref([]);


onMounted(() => {
  paymentMethod.value = new PaymentMethod();
});
function createValidationMessages(): void {
  if (paymentMethod.value.creditCard) {
    let creditCardValidated = false;

    if (!paymentMethod.value.nameOnCard) {
      const error = {
        name: "nameOnCard",
        value: "Name on card is required.",
      };
      validationErrors.value.push(error);
    }
    if (!paymentMethod.value.cardNumber) {
      const error = {
        name: "cardNumber",
        value: "Card number is required.",
      };
      validationErrors.value.push(error);
    } else {
      creditCardValidated = validateCard(paymentMethod.value.cardNumber);
      if (!creditCardValidated) {
        const error = {
          name: "cardNumber",
          value:
            "Entered card is not supported. We support Master card, Visa, American Express and Discover.",
        };
        validationErrors.value.push(error);
      }
    }
    if (!paymentMethod.value.cvv) {
      const error = {
        name: "cvv",
        value: "CVC is required.",
      };
      validationErrors.value.push(error);
    } else if (creditCardValidated) {
      if (
        !validateCVV(paymentMethod.value.cardNumber, paymentMethod.value.cvv)
      ) {
        const error = {
          name: "cvv",
          value: "Invalid CVC number.",
        };
        validationErrors.value.push(error);
      }
    }
    if (!paymentMethod.value.expDateMonth) {
      const error = {
        name: "expDateMonth",
        value: "Month is required.",
      };
      validationErrors.value.push(error);
    }
    if (!paymentMethod.value.expDateYear) {
      const error = {
        name: "expDateYear",
        value: "Year is required.",
      };
      validationErrors.value.push(error);
    }
  }
}
function clearValidationMessage(name: string): void {
  const elements = validationErrors.value.filter((element) => {
    return element.name == name;
  });
  elements.forEach((element) => {
    const index = validationErrors.value.indexOf(element);
    validationErrors.value.splice(index, 1);
  });
}

function validatedFieldChanged(event: any): void {
  clearValidationMessage(event.target.name);
}

function hasErrors(name: string): boolean {
  return (
    validationErrors.value.find((element) => {
      return element.name == name;
    }) != null
  );
}

function changePaymentInfo() {
  if (!validated.value) {
    createValidationMessages();
    return;
  }
  emit("payment-changed", paymentMethod);
  //closeModal("ChangePaymentInfoModal", modalPop);
}
//This function is not used
// function onShow() {
//   // Reset user on new show
//   paymentMethod.value = new PaymentMethod();
// }

const cardYears: ComputedRef<string[]> = computed(() => {
  const result = [];
  const currentYear = new Date().getFullYear();
  for (let i = currentYear; i < currentYear + 20; i++) {
    result.push(i.toString());
  }
  return result;
});

const cardMonths: ComputedRef<string[]> = computed(() => {
  const result = [];
  for (let i = 1; i <= 12; i++) {
    result.push(pad(i, 2));
  }
  return result;
});

function pad(num: number, size: number) {
  let res = num.toString();
  while (res.length < size) res = "0" + num;
  return res;
}

const validated = computed(() => {
  let result = true;

  if (paymentMethod.value.creditCard) {
    const crediCardValidated =
      Boolean(paymentMethod.value.nameOnCard) &&
      Boolean(paymentMethod.value.cardNumber) &&
      Boolean(paymentMethod.value.cvv) &&
      Boolean(paymentMethod.value.expDateMonth) &&
      Boolean(paymentMethod.value.expDateYear);
    result = result && crediCardValidated;

    if (result) {
      const creditCardValidated = validateCard(paymentMethod.value.cardNumber);
      if (!creditCardValidated) {
        return false;
      }
      result =
        result &&
        validateCVV(paymentMethod.value.cardNumber, paymentMethod.value.cvv);
    }
  }
  if (!result) {
    return false;
  }

  return result;
});

return (_ctx: any,_cache: any) => {
  const _component_center = _resolveComponent("center")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('nameOnCard') }])
          }, [
            _createTextVNode("Name on Card "),
            _hoisted_4
          ], 2),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((paymentMethod.value.nameOnCard) = $event)),
            type: "text",
            name: "nameOnCard",
            class: _normalizeClass({ validationfield: hasErrors('nameOnCard') }),
            onInput: validatedFieldChanged
          }, null, 34), [
            [_vModelText, paymentMethod.value.nameOnCard]
          ]),
          _createVNode(ValidationError, {
            name: "nameOnCard",
            errors: validationErrors.value
          }, null, 8, ["errors"])
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", {
            class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('cardNumber') }])
          }, [
            _createTextVNode("Card Number "),
            _hoisted_7
          ], 2),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((paymentMethod.value.cardNumber) = $event)),
            type: "text",
            name: "cardNumber",
            class: _normalizeClass({ validationfield: hasErrors('cardNumber') }),
            onInput: validatedFieldChanged
          }, null, 34), [
            [_vModelText, paymentMethod.value.cardNumber],
            [_directive_maska, { mask: '################' }]
          ]),
          _createVNode(ValidationError, {
            name: "cardNumber",
            errors: validationErrors.value
          }, null, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            src: require('@/assets/images/creditcards-logo.png'),
            width: "253",
            height: "48",
            alt: "Credit Cards Payment Method"
          }, null, 8, _hoisted_9)
        ]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("label", {
            class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('cvv') }])
          }, [
            _createTextVNode("CVC "),
            _hoisted_12
          ], 2),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((paymentMethod.value.cvv) = $event)),
            type: "text",
            name: "cvv",
            class: _normalizeClass({ validationfield: hasErrors('cvv') }),
            onInput: validatedFieldChanged
          }, null, 34), [
            [_vModelText, paymentMethod.value.cvv],
            [_directive_maska, { mask: '####' }]
          ]),
          _hoisted_13,
          _createVNode(ValidationError, {
            name: "cvv",
            errors: validationErrors.value
          }, null, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", {
            class: _normalizeClass(["tinylabel", { validationlabel: hasErrors('expDateMonth') }])
          }, [
            _createTextVNode("Expiration Date "),
            _hoisted_15
          ], 2),
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((paymentMethod.value.expDateMonth) = $event)),
              class: _normalizeClass(["plainfieldselect", { validationfield: hasErrors('expDateMonth') }]),
              placeholder: "Select Month",
              name: "expDateMonth",
              onChange: validatedFieldChanged
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardMonths.value, (month) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: month,
                  value: month
                }, _toDisplayString(month), 9, _hoisted_17))
              }), 128))
            ], 34), [
              [_vModelSelect, paymentMethod.value.expDateMonth]
            ]),
            _createVNode(ValidationError, {
              name: "expDateMonth",
              errors: validationErrors.value
            }, null, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((paymentMethod.value.expDateYear) = $event)),
              class: _normalizeClass(["plainfieldselect", { validationfield: hasErrors('expDateYear') }]),
              placeholder: "Select Year",
              name: "expDateYear",
              onChange: validatedFieldChanged
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardYears.value, (year) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: year,
                  value: year
                }, _toDisplayString(year), 9, _hoisted_19))
              }), 128))
            ], 34), [
              [_vModelSelect, paymentMethod.value.expDateYear]
            ]),
            _createVNode(ValidationError, {
              name: "expDateYear",
              errors: validationErrors.value,
              style: {"float":"right"}
            }, null, 8, ["errors"])
          ])
        ])
      ]),
      _hoisted_20,
      _createVNode(_component_center, null, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            class: _normalizeClass({ disabled: !validated.value }),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (changePaymentInfo()))
          }, " Submit ", 2)
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})